import { Injectable } from '@angular/core';

import { PromotionsModel } from '@bytel/bytel-sales';
import { CheckoutCartModel, IProductToAddInQuote, PromotionRepository } from '@bytel/checkout';

import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PromotionsService {
    public constructor(private promoRepo: PromotionRepository) {}

    public getPromotionForProducts(
        cart: CheckoutCartModel,
        products: IProductToAddInQuote,
        quoteIndex: number = cart.currentQuoteIndex,
        rio: string = null,
    ): Observable<PromotionsModel> {
        const quote = cart.getQuote(quoteIndex);
        if (quote) {
            const productsInQuote = quote.products.map((product) => product.gencode);
            Object.keys(products).forEach((p) => {
                if (productsInQuote.includes(p)) {
                    delete products[p];
                }
            });
        }

        return this.promoRepo.getPromotions(cart, products, [], rio);
    }
}
